import { Badge } from "../ui/Badge";

type ShapeName = "circle" | "square" | "triangle" | "question";

const matrix: ShapeName[][] = [
  ["circle", "square", "triangle"],
  ["square", "triangle", "circle"],
  ["triangle", "circle", "question"]
];

const options: ShapeName[] = ["circle", "square", "triangle", "square"];

function Shape({ shape }: { shape: ShapeName }) {
  if (shape === "question") {
    return <span className="text-2xl font-bold text-cyan-100">?</span>;
  }

  if (shape === "triangle") {
    return (
      <svg className="h-10 w-10 drop-shadow-[0_0_14px_rgb(34_211_238_/_0.35)]" viewBox="0 0 48 48" aria-hidden="true">
        <path d="M24 7 43 40H5L24 7Z" fill="none" stroke="currentColor" strokeWidth="4" className="text-violet-200" />
      </svg>
    );
  }

  return (
    <span
      aria-hidden="true"
      className={
        shape === "circle"
          ? "h-9 w-9 rounded-full border-4 border-cyan-200 shadow-[0_0_18px_rgb(34_211_238_/_0.32)]"
          : "h-9 w-9 rounded-md border-4 border-blue-200 shadow-[0_0_18px_rgb(59_130_246_/_0.32)]"
      }
    />
  );
}

export function PreviewChallengeCard() {
  return (
    <aside className="glass-panel mx-auto w-full max-w-[31rem] rounded-[1.75rem] border-cyan-200/20 p-4 shadow-[0_30px_90px_rgb(0_0_0_/_0.34),0_0_55px_rgb(34_211_238_/_0.12)] sm:p-5 lg:p-6" aria-label="Δείγμα ερώτησης Brain Test">
      <div className="flex items-center justify-between gap-3">
        <Badge>Δείγμα ερώτησης</Badge>
        <span className="rounded-full border border-white/10 bg-white/8 px-3 py-1 text-xs font-semibold text-slate-200 shadow-[inset_0_1px_0_rgb(255_255_255_/_0.06)]">1 / 30</span>
      </div>
      <h2 className="mx-auto mt-6 max-w-sm text-center text-lg font-semibold leading-snug text-white">Ποιο σχήμα συμπληρώνει σωστά το μοτίβο;</h2>
      <div className="mx-auto mt-5 grid aspect-square w-full max-w-[22.5rem] grid-cols-3 gap-2 rounded-3xl border border-cyan-200/12 bg-slate-950/48 p-2.5 shadow-[inset_0_1px_0_rgb(255_255_255_/_0.05)]">
        {matrix.flatMap((row, rowIndex) =>
          row.map((shape, columnIndex) => (
            <div
              key={`${rowIndex}-${columnIndex}`}
              className="flex min-h-16 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.05] shadow-[inset_0_1px_0_rgb(255_255_255_/_0.04)]"
            >
              <Shape shape={shape} />
            </div>
          ))
        )}
      </div>
      <div className="mx-auto mt-5 grid w-full max-w-[29rem] grid-cols-2 gap-3 sm:grid-cols-4" aria-label="Επιλογές απάντησης">
        {options.map((shape, index) => (
          <button
            key={`${shape}-${index}`}
            type="button"
            className="group relative flex min-h-[5.75rem] items-center justify-center rounded-2xl border border-cyan-200/14 bg-slate-950/42 shadow-[0_12px_34px_rgb(0_0_0_/_0.20),inset_0_1px_0_rgb(255_255_255_/_0.055)] transition hover:border-cyan-200/60 hover:bg-cyan-200/10 hover:shadow-[0_18px_44px_rgb(14_165_233_/_0.13),inset_0_1px_0_rgb(255_255_255_/_0.07)]"
            aria-label={`Επιλογή ${index + 1}`}
          >
            <span className="absolute left-2 top-2 flex h-5 w-5 items-center justify-center rounded-full border border-cyan-200/35 bg-white/[0.065] text-[0.65rem] font-bold text-cyan-100 shadow-[inset_0_1px_0_rgb(255_255_255_/_0.08)]">
              {index + 1}
            </span>
            <span className="flex items-center justify-center transition group-hover:scale-105">
              <Shape shape={shape} />
            </span>
          </button>
        ))}
      </div>
      <div className="mx-auto mt-5 grid w-full max-w-[29rem] gap-2 border-t border-white/10 pt-4 text-xs text-slate-300 sm:grid-cols-2">
        <span>Δυσκολία: <strong className="text-cyan-100">Adaptive</strong></span>
        <span>Εκτίμηση χρόνου: <strong className="text-cyan-100">8–12 λεπτά</strong></span>
      </div>
    </aside>
  );
}
